import ILinksNavigationProxyService from "./links_navigation_proxy_service_interface";
import {
    ILinksNavigationService, INavigateLinkOptions, IOpenUrlOptions
} from "../../../../app-react/services/links-navigation/links-navigation.service.interface";
import {
    LinkNavigationId
} from "../../../../app-react/services/configurations/config-data-sections/generated-config-const";
import BaseService from "../../base/base_service";

interface LinksNavigationProxyServiceParams {
    linksNavigation: () => ILinksNavigationService;
}

export default class LinksNavigationProxyService extends BaseService implements ILinksNavigationProxyService {
    static CLASS = 'LinksNavigationProxyService';

    private _params: LinksNavigationProxyServiceParams;

    init(params: LinksNavigationProxyServiceParams) {
        this._params = params;
    }
    
    private get _linksNavigation(): ILinksNavigationService {
        return this._params.linksNavigation();
    }

    getLinkUrl(linkId: LinkNavigationId): string {
        return this._linksNavigation.getLinkUrl(linkId);
    }

    navigateLink(options: INavigateLinkOptions): Promise<void> {
        return this._linksNavigation.navigateLink(options);
    }

    openGamingHistoryPage(): Promise<void> {
        return this._linksNavigation.openGamingHistoryPage();
    }

    openPoker(): Promise<void> {
        return this._linksNavigation.openPoker();
    }

    openSport(): Promise<void> {
        return this._linksNavigation.openSport();
    }

    openUrl(options: IOpenUrlOptions): Promise<void> {
        return this._linksNavigation.openUrl(options);
    }

    openResponsibleGaming(): Promise<void> {
        return this._linksNavigation.openResponsibleGaming();
    }

    openSecondaryResponsibleGaming(): Promise<void> {
        return this._linksNavigation.openSecondaryResponsibleGaming();
    }

    openSelfTest(): Promise<void> {
        return this._linksNavigation.openSelfTest();
    }

    openSelfExclusion(): Promise<void> {
        return this._linksNavigation.openSelfExclusion();
    }

    openSafeToPlay(): Promise<void> {
        return this._linksNavigation.openSafeToPlay();
    }
}